<template>
  <div>
    <v-card dark>
      <v-card-title>
        <h2>Specials</h2>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :pagination.sync="pagination" :loading="loading" light :search="search" :headers="headers"
        :items="specials" class="elevation-1">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.id }}</td> -->
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.created | convertDate }}</td>
          <td>{{ props.item.startDate | convertDate }}</td>
          <td>{{ props.item.endDate | convertDate }}</td>
          <td>
            <v-icon color="primary" @click="editSpecial(props.item)">edit</v-icon>
            <v-icon color="error" @click="deleteSpecial(props.item)">delete</v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no
          results.
        </v-alert>
      </v-data-table>
    </v-card>

    <v-btn color="primary" @click.stop="createSpecialDialog = true" style="margin-left:0px;">Create Special</v-btn>

    <v-dialog v-model="createSpecialDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <h3>Create Special</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-text-field v-model="title" label="Title" id="title" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="description" label="Description" id="description" required></v-text-field>
              </v-flex>
              <v-flex>
                <datetime input-id="startDate" v-model="startDate" input-class="dateTimeInput" :week-start="7" auto>
                  <label for="startDate" slot="before">Start Date</label>
                </datetime>
              </v-flex>
              <br>
              <v-flex>
                <datetime input-id="endDate" v-model="endDate" input-class="dateTimeInput" :week-start="7" auto>
                  <label for="endDate" slot="before">End Date</label>
                </datetime>
              </v-flex>
              <v-flex>
                <v-btn raised color="primary" @click="onPickFile">Upload Image</v-btn>
                <input type="file" style="display:none;" ref="fileInput" accept="image/*" @change="onFilePicked">
              </v-flex>
              <v-flex>
                <img :src="imageUrl" height="150">
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat v-on:click="closeCreateDialog">Close</v-btn>
          <v-btn color="success" v-on:click="createSpecial" :disabled="!isComplete">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import Special from "../../../store/models/Special.js";

  export default {
    data() {
      return {
        headers: [{
            text: "Title",
            align: "left",
            value: "title"
          },
          {
            text: "Description",
            align: "left",
            value: "description"
          },
          {
            text: "Created",
            align: "left",
            value: "created"
          },
          {
            text: "Start Date",
            align: "left",
            value: "startDate"
          },
          {
            text: "End Date",
            align: "left",
            value: "endDate"
          },
          {
            text: "Actions",
            align: "left",
            value: "id"
          }
        ],
        search: "",
        pagination: {
          sortBy: "created",
          descending: "true"
        },
        createSpecialDialog: false,
        title: "",
        description: "",
        startDate: "",
        endDate: "",
        imageUrl: "",
        image: null
      };
    },
    filters: {
      convertDate: function (t) {
        return new Date(t).toLocaleDateString();
      }
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        specials: "getSpecials"
      }),
      isComplete() {
        return this.title && this.description && this.startDate && this.endDate;
      }
    },
    methods: {
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrl = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        this.image = files[0];
      },
      // creates a new special
      createSpecial() {
        let id = 0;
        let specialImage = this.image;

        let special = new Special(
          0,
          this.title,
          this.description,
          this.image,
          "",
          "",
          new Date().toISOString(),
          new Date(this.startDate).toISOString(),
          new Date(this.endDate).toISOString()
        );

        this.$store.dispatch("createSpecial", special);

        this.closeCreateDialog();
      },
      editSpecial(special) {
        this.$store.commit("setSpecialToEdit", special);
        this.$router.push({
          path: "Specials/Edit"
        });
      },
      deleteSpecial(special) {
        this.$confirm("Do you really want to delete this special?").then(res => {
          if (res) {
            this.$store.dispatch("deleteSpecial", special);
          }
        });
      },
      // cleans up the form and closes the dialog
      closeCreateDialog() {
        this.title = "";
        this.description = "";
        this.endDate = "";
        this.imageUrl = "";
        this.image = null;
        this.createSpecialDialog = false;
      }
    },
    // when page loads retrieve the specials
    created: function () {
      // set listener for changes to specials collection
      this.$store.dispatch("getAllSpecials");
    }
  };
</script>